angular
  .module('cfn')
  .factory('userSettingsService', [
    '$rootScope',
    'i18nFilter',
    'languageService',
    userSettingsService
  ]);
function userSettingsService($rootScope, i18nFilter, languageService) {
  'use strict';

  var userSettings, inSyncCheck;
  (function() {
    userSettings = getUserSettingsFromCredentials();

    if (cfnGlobals.isDev) {
      //if we are in a development environment check the values managed here are not changed from the outside.
      inSyncCheck = function() {
        if (
          JSON.stringify(userSettings) !==
          JSON.stringify(getUserSettingsFromCredentials())
        ) {
          console.error(
            'Settings are out of sync! They were modified without using the setter!',
            userSettings,
            getUserSettingsFromCredentials()
          );
        }
        userSettings = getUserSettingsFromCredentials();
      };
    } else {
      inSyncCheck = function() {
        userSettings = getUserSettingsFromCredentials();
      };
    }
  })();

  // @deprecated wtf is the use of this???
  function getValue(varAsString, allowEmpty) {
    if (varAsString) {
      var path = varAsString.split('.');
      var current = window[path.shift()];
      //follow dot notation if possible
      while (angular.isObject(current) && path.length > 0) {
        current = current[path.shift()];
      }
      //if path is depleted we found it.
      if (
        (path.length == 0 && allowEmpty) || // current = areaUnit;
        (current !== undefined && current !== null)
      ) {
        return current;
      }
    }
  }

  function getUserSettingsFromCredentials() {
    return {
      areaUnit: getValue('app.credentials.company.areaUnit', 'AREAL_HA'),
      //ISO 3166-1 alpha-3
      country: getValue('app.credentials.company.countryIsoCode', 'DEU')
    };
  }

  function getAreaUnitEnum() {
    inSyncCheck();
    return userSettings.areaUnit;
  }

  function getIsoCountryEnum() {
    inSyncCheck();
    return userSettings.country;
  }

  return {
    /** The user locale. The complete language and alpha 2 country code (de-DE, en-GB) */
    getLocale: function() {
      return languageService.getLanguage();
    },
    setLocale: function(newValue) {
      languageService.setLanguage(newValue);
    },

    /** simple alpha 2 iso language code (de, en, es, ...) */
    getLanguage: function() {
      return languageService.getPrimaryLanguage();
    },

    /** The translated company wide area unit */
    getAreaUnit: function() {
      return enums.UnitsArealEnum[getAreaUnitEnum()];
    },

    /** The company wide area unit enum */
    getAreaUnitEnum: getAreaUnitEnum,
    setAreaUnitEnum: function(newValue) {
      userSettings.locale = newValue;
      app.credentials.company.areaUnit = newValue;
    },
    getIsoCountryEnum: getIsoCountryEnum
  };
}
